module.exports = __webpack_public_path__ + "img/compact.6ae50fd1.png";